var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolumeControlinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#volume-control_inline_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.583 1.91L3.642 6.847a.208.208 0 01-.148.061H1.667A1.667 1.667 0 000 8.576v2.845a1.667 1.667 0 001.667 1.667h1.827a.21.21 0 01.148.061l4.941 4.938A.833.833 0 0010 17.5v-15a.833.833 0 00-1.417-.59zM14.658 4.138a.833.833 0 00-1.178 1.179 6.62 6.62 0 010 9.365.833.833 0 001.178 1.179 8.287 8.287 0 000-11.723z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.702 2.028a.833.833 0 00-1.178 1.178 9.618 9.618 0 010 13.584.835.835 0 101.178 1.178 11.286 11.286 0 000-15.94zM12.616 6.25a.834.834 0 00-1.18 1.178 3.65 3.65 0 010 5.149.835.835 0 00-.034 1.214.833.833 0 001.214-.04 5.319 5.319 0 000-7.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "volume-control_inline_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgVolumeControlinline;